/**
 * Application wide configuration
 */
const config = {
  baseURI: "https://annies-backend.herokuapp.com/",
  payPal: process.env.REACT_APP_API_PAYPAL,
  esewaImageUrl: process.env.REACT_APP_ESEWA_IMAGE_URL,
 // esewaPaymentUrl: process.env.REACT_APP_ESEWA_PAYMENT_URL,
  apiEndPoint: {
    product: {
      fetchProducts: '/api/v1/product',
      fetchProduct: '/api/v1/product/:id',
      fetchProductReviews: '/api/v1/product/:id/reviews',
      createReview: '/api/v1/product/:id/reviews',
      deleteProduct: '/api/v1/product/:id',
      createProduct: '/api/v1/product',
      updateProduct: '/api/v1/product/:id',
    },
    shipping: {
      fetchShippings: '/api/v1/shipping',
      fetchShipping: '/api/v1/shipping/:id',
      deleteShipping: '/api/v1/shipping/:id',
      createShipping: '/api/v1/shipping',
      updateShipping: '/api/v1/shipping/:id',
    },
    user: {
      login: '/api/v1/auth/login',
      create: '/api/v1/auth/register',
      fetchUsers: '/api/v1/user',
      verifyEmail: '/api/v1/auth/verify-email',
      deleteUser: '/api/v1/user/:id',
      updateUser: '/api/v1/user/:id',
      fetchUser: '/api/v1/user/:id',
      forgotPassword: '/api/v1/auth/forgot-password',
      resetPassword: '/api/v1/auth/reset-password',
    },
    order: {
      createOrder: '/api/v1/order',
      order: '/api/v1/order/:id',
      approveOrder: '/api/v1/order/:id/approve',
      cancelOrder: '/api/v1/order/:id/cancel',
      payOrder: '/api/v1/order/:id/pay',
      deliverOrder: '/api/v1/order/:id/deliver',
      userOrder: '/api/v1/order/auth-orders',
      orders: '/api/v1/order',
      deleteOrder: '/api/v1/order/:id',
    },
  },
};

export default config;
